module.exports = __webpack_public_path__ + "img/Sprogreformation_Henrik_Wegeland.c53b7233.jpg";